<script>

  export default
  {
    apiUrl:'http://api.modiankj.com',
    //apiUrl:'http://api-online.modiankj.com',
    webUrl:'http://wx.modiankj.com',
    //webUrl:'http://wx-online.modiankj.com',
    pageSize:10

  }
</script>


// WEBPACK FOOTER //
// src/components/global.vue